<template>
  <div :class="$style.winning">
    <div :class="$style.mask" @touchmove.prevent></div>
    <div :class="$style.context">
      <div :class="$style.window">
        <h1>{{ `恭喜您获得了【${giftData.gift_name}】` }}</h1>
        <!-- 游戏道具类 -->
        <div :class="$style.contentBox" v-if="giftData.gift_type === 1">
          <p>
            {{
              `对应礼包码为：${giftData.gift_code}，复制后进入游戏即可获取。如有问题，请`
            }}
            <a @click="showCustomer">联系客服</a>
          </p>
          <Button
            :class="[$style.contactBtn, 'copyBtn']"
            :data-clipboard-text="giftData.gift_code"
            >复制礼包码</Button
          >
        </div>

        <!-- 代金券类 -->
        <div :class="$style.contentBox" v-if="giftData.gift_type === 2">
          <p>
            请进入游戏，点击悬浮窗中代金券模块，进行查收，如有问题，请
            <a @click="showCustomer">联系客服</a>
          </p>
          <Button :class="$style.contactBtn" @click="$emit('openDownloadLink')"
            >进入游戏</Button
          >
        </div>

        <!-- 实物奖励类 -->
        <div
          :class="[$style.contentBox, $style.formBox]"
          v-if="giftData.gift_type === 3"
        >
          <p>
            实物奖品系统不能自动发放，请准确填写真实有效的电话号码及邮寄地址。（我们将于活动结束后，依次发出，如有问题，请
            <a @click="showCustomer">联系客服</a>）
          </p>

          <Form :class="$style.form" @submit="onSubmit">
            <Field
              :class="$style.formItem"
              v-model="formData.real_name"
              name="real_name"
              label="姓名"
              :readonly="flag"
              :rules="[{ required: true, message: '请填写姓名' }]"
            ></Field>
            <Field
              :class="$style.formItem"
              v-model="formData.mobile"
              name="mobile"
              label="联系方式"
              :readonly="flag"
              :rules="[{ required: true, message: '请填写联系方式' }]"
            ></Field>
            <Field
              :class="$style.formItem"
              v-model="formData.address"
              name="address"
              label="具体地址"
              :readonly="flag"
              :rules="[{ required: true, message: '请填写具体地址' }]"
            ></Field>
            <Button v-if="!flag" :class="$style.contactBtn" native-type="submit"
              >提交</Button
            >
          </Form>
        </div>
      </div>
      <i class="iconfont yw-close" @click="$emit('close')"></i>
    </div>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import { Toast, Field, Form } from "vant";
import { mapActions, mapState } from "vuex";
import { userAddress } from "@/apis/recall";

export default {
  name: "",
  components: {
    Field,
    Form,
  },
  data() {
    return {
      formData: {
        real_name: "",
        mobile: "",
        address: "",
      },
      flag: false,
    };
  },
  props: {
    giftData: {
      type: Object,
      default: () => {
        return {
          id: 0,
          type: 0, // 1.红包领取，2.抽奖
          gift_type: 0,
          gift_name: "",
          gift_code: "",
          activityId: 0,
          address: {
            address_str: "",
            mobile: "",
            real_name: "",
          },
          addressF: false,
        };
      },
    },
  },
  mounted() {
    this.copyInit();
    this.isSet();
  },
  computed: {
    ...mapState({
      template_id: (state) => state.recall.template_id,
    }),
  },
  methods: {
    ...mapActions({
      showCustomer: "recall/showCustomer",
    }),
    isSet() {
      if (this.giftData.address && this.giftData.address.address_str) {
        this.formData.address = this.giftData.address.address_str;
        this.formData.real_name = this.giftData.address.real_name;
        this.formData.mobile = this.giftData.address.mobile;
        this.flag = true;
      }
    },
    copyInit() {
      if (this.code) {
        this.copy = new Clipboard(".copyBtn");
        this.copy.on("success", () => {
          Toast("复制成功");
        });
      }
    },
    contact(type) {
      if (!type) {
        this.showCustomer();
      } else {
        window.open(
          "https://wpa1.qq.com/Q2eB66Xo?_type=wpa&qidian=true",
          "_blank"
        );
      }
    },
    async onSubmit(values) {
      if (this.flag) return;
      if (this.addressF) return;
      const regM = new RegExp(
        /^1([358][0-9]|4[01456879]|6[2567]|7[0135678]|9[012356789])[0-9]{8}$/
      );
      const regN = new RegExp(/^[a-zA-Z0-9\u4e00-\u9fa5]{0,10}$/);
      const regA = new RegExp(/^[a-zA-Z0-9\u4e00-\u9fa5]{0,50}$/);
      if (!regM.test(values.mobile)) {
        Toast("手机号码有误，请检查后重新填写~");
        return;
      }
      if (!regN.test(values.real_name)) {
        Toast("姓名超过长度限制，请控制在10个字以内，请检查后重新填写~");
        return;
      }
      if (!regA.test(values.address)) {
        Toast("地址超过长度限制，请控制在50个字以内，请检查后重新填写~");
        return;
      }
      this.addressF = true;
      console.log({ activity_id: this.giftData.activityId });
      const obj = {
        id: this.giftData.id,
        type: this.giftData.type,
        template_id: this.template_id,
        activity_id: this.giftData.activityId,
        ...values,
      };
      const r = await userAddress(obj);
      if (r.ret !== 1) {
        this.addressF = false;
        return;
      }
      this.flag = true;
      Toast("提交成功，请等待奖励发放~");
      this.$emit("close");
      this.$emit("freshRecord");
    },
  },
};
</script>

<style lang="scss" module>
.lighter {
  color: #3cc0ff;
}
@mixin border-bottom-1px($left: 0, $width: 100%) {
  position: relative;
  &:before {
    display: block;
    position: absolute;
    left: $left;
    bottom: 1px;
    width: $width;
    border-top: 1px solid #ececec;
    content: " ";
    z-index: 1;
  }
}

.winning {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.65);
  }
  .context {
    position: absolute;
    width: 351px;
    height: 325px;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    color: #9f9f9f;
    .window {
      width: 351px;
      min-height: 255px;
      background: #ffffff;
      border-radius: 12px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      padding: 30px 12px;
      > h1 {
        color: #000000;
        font-size: 15px;
        margin-bottom: 10px;
        text-align: center;
      }
      .contentBox {
        > p {
          line-height: 26px;
          margin: 30px 0px;
          > a {
            color: #24b4fe;
          }
        }
      }
      .formBox {
        > p {
          margin: 20px 0px;
        }
        .form {
          width: 100%;
          height: auto;
          .formItem {
            // height: 50px;
            // background-color: black;
          }
        }
      }
      .contactBtn {
        width: 247px;
        height: 43px;
        border: none;
        outline: none;
        background: linear-gradient(-90deg, #24b4fe, #52d0ff);
        border-radius: 22px;
        color: #ffffff;
        display: block;
        margin: auto {
          top: 17px;
        }
        &:active {
          -webkit-filter: brightness(110%);
          filter: brightness(110%);
        }
      }
    }
    :global {
      .yw-close {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        color: #ffffff;
        font-size: 50px;
        z-index: 1;
        margin: auto;
        font-weight: 100;
      }
    }
  }
}
</style>